import backgroundRed from "@/assets/background_red.svg";
import PatternBackground from "@/components/PatternBackground";

export default function SessionsSignedOut() {
  return (
    <PatternBackground background={backgroundRed}>
      <div className="flex min-h-[28rem] w-full max-w-4xl flex-col items-center justify-center rounded-[40px] border-2 border-ink bg-white px-8 py-24 text-center shadow-sm sm:px-20 sm:py-32">
        <h1 className="font-sans text-5xl leading-tight text-ink sm:text-7xl">
          Sesión cerrada
          <br />
          con éxito
        </h1>
        <p className="mt-10 font-sans text-lg font-light text-ink/80 sm:text-xl">
          Tu sesión fue cerrada exitósamente.
          <br />
          <strong className="font-bold text-ink">
            ¡Esperamos que vuelvas pronto!
          </strong>
        </p>
      </div>
    </PatternBackground>
  );
}
